<template>
  <div class="clipboard-flyout">
    <p v-if="parsedRecords.length == 0 && !loading">No Customized SKUs</p>
    <div v-else-if="loading">
      <loading-spinner ></loading-spinner>
    </div>
    <div v-else>
      <div class="clipboard-items">
        <!-- Loop over all records. -->
        <div v-for="record in parsedRecords" :key="record.id" class="custom_SKU" :class="{ 'tombstone' : record.deleted }">
          <!-- Product Details -->
          <a class="product" :href="`/config/clipboard/${record.uid}#summary`">
            <img
              v-if="record.product.thumbnail && record.product.thumbnail.src"
              :src="record.product.thumbnail.src.url" :srcset="record.product.thumbnail.srcset"
              sizes="(max-width: 20.625em) 21vw, (max-width: 34em) 13vw, (max-width: 46.875em) 9vw, (max-width: 61.9375em) 8vw, (max-width: 68.75em) 7vw, 70px"
              :alt="record.product.title"
            >
            <div class="txt">
              <h4>{{ record.product.title }}</h4>
              <h6>{{ record.customizationsCount }} Customizations</h6>
            </div>
          </a>
          <!-- Action Buttons -->
          <div class="actions">
            <a :href="`/config/clipboard/${record.uid}`" @click="storeCurrentUrl" class="edit">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>Edit Icon</title>
                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill-rule="nonzero"/>
              </svg>
              Edit
            </a>
            <!-- Delete Record Button, contains modal -->
            <delete-record-button :record="record" @refresh="$emit('refresh')"></delete-record-button>
          </div>
        </div>
      </div>
      <!-- Quote Request Button, contains modal -->
      <quote-request :configurations="parsedRecords">
        Get a Quote
      </quote-request>
    </div>
  </div>
</template>

<script>
  import DeleteRecordButton from './DeleteRecordButton'
  import QuoteRequest from '../QuoteRequest'
  import LoadingSpinner from '../../../atoms/loading_spinner.js';

  export default {
    components: {
      QuoteRequest,
      DeleteRecordButton,
      LoadingSpinner
    },
    props: [
      'records',
      'loading'
    ],
    computed: {
      parsedRecords() {
        return this.records ? this.records : [];
      }
    },
    methods: {
      storeCurrentUrl() {
        this.$emit('updateConfigRedirectBack', window.location.href);
      }
    },
  }
</script>
